<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
   <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <circle stroke="currentColor" cx="12" cy="12" r="2.5"></circle>
    <circle stroke="currentColor" cx="12" cy="20" r="2.5"></circle>
    <circle stroke="currentColor" cx="12" cy="4" r="2.5"></circle>
  </g>
</svg>
